
import * as React from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt, faSearch, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import UnstyledDropdownToggle from 'components/bootstrap_extensions/bs5/unstyled_dropdown_toggle';

import { clickAsLink } from 'helpers/link_helpers';

import Details from './details';

export default function Item({ requirement, onDelete }) {
  const handleSearchProperties = (e) => {
    clickAsLink(window, requirement.searchPath, e);
  };

  const handleEditRequirement = (e) => {
    clickAsLink(window, requirement.editPath, e);
  };

  const renderDropdown = () => {
    return (
      <Dropdown id="requirements-action-dropdown">
        <Dropdown.Toggle as={UnstyledDropdownToggle}>
          <FontAwesomeIcon className="px-2 text-muted" icon={faEllipsisV}/>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            className="ps-3"
            eventKey={1}
            name="edit-btn"
            onClick={e => handleEditRequirement(e)}
          >
            <FontAwesomeIcon icon={faPencilAlt}/>
            Edit Requirement
          </Dropdown.Item>
          <Dropdown.Item
            className="ps-3"
            eventKey={2}
            name="search-btn"
            onClick={e => handleSearchProperties(e)}
          >
            <FontAwesomeIcon icon={faSearch}/>
            Search for matching Properties
          </Dropdown.Item>
          <Dropdown.Item
            className="ps-3"
            eventKey={3}
            name="delete-btn"
            onClick={() => onDelete(requirement)}
          >
            <FontAwesomeIcon icon={faTrashAlt}/>
            Delete Requirement
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <a href={requirement.searchPath}>
          <strong>{requirement.name}</strong>
        </a>

        {renderDropdown()}
      </div>
      <Details requirement={requirement} />
    </>
  );
}

Item.propTypes = {
  requirement: PropTypes.shape({
    buildingSize: PropTypes.string,
    editPath: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    leaseDate: PropTypes.string,
    lotSize: PropTypes.string,
    name: PropTypes.string.isRequired,
    notes: PropTypes.string,
    numberOfUnits: PropTypes.string,
    propertyTypes: PropTypes.string,
    salePrice: PropTypes.string,
    searchPath: PropTypes.string.isRequired,
    transactionType: PropTypes.string.isRequired
  }).isRequired,
  onDelete: PropTypes.func.isRequired
};
